import React, { forwardRef, useImperativeHandle, useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { FormField } from '../form-field/form-field';
import { IconChevronDown } from '../icons';

export type SelectProps = {
  size?: 'small' | 'medium' | 'large';
  invalid?: boolean;
  help?: React.ReactNode;
  label?: React.ReactNode;
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'>;

export const Select = forwardRef(
  (
    { label, invalid, className, size = 'medium', help, children, ...selectProps }: SelectProps,
    ref: React.Ref<HTMLSelectElement | null>
  ) => {
    const [selectedLabel, setSelectedLabel] = useState<string | null>();

    const internalRef = useRef<HTMLSelectElement>(null);
    // Expose the internal ref as the forwarded ref
    useImperativeHandle(ref, () => internalRef.current);

    useEffect(() => {
      if (internalRef.current) {
        setSelectedLabel(internalRef.current.selectedOptions[0]?.textContent);
      }
    });

    const classNames = classnames(className, 'airtame-select', `airtame-select--${size}`);

    return (
      <FormField
        label={label}
        invalid={invalid}
        labelPlacement="top"
        help={help}
        disabled={selectProps.disabled}
        className={classNames}
      >
        <select ref={internalRef} className="airtame-select__replaced" {...selectProps}>
          {children}
        </select>
        <div className="airtame-select__input">
          {selectedLabel}
          <IconChevronDown className="airtame-select__icon" />
        </div>
      </FormField>
    );
  }
);

Select.displayName = 'Select';
